import { render } from "./project_two_columns.vue?vue&type=template&id=095e9aa7"
import script from "./project_two_columns.vue?vue&type=script&lang=js"
export * from "./project_two_columns.vue?vue&type=script&lang=js"

import "./project_two_columns.vue?vue&type=style&index=0&id=095e9aa7&lang=scss"

import exportComponent from "/home/forge/binalogue.stage-preview.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__